import * as Yup from "yup";

export const payorlinkLoginSchema = () => {
  return Yup.object().shape({
    icareMemberId: Yup.string()
      .required("This field is required")
      .matches(/^[0-9]+$/, "Please enter a valid iCare Member ID"),
  });
};
